function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 10.0738V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V10.0738L12.5548 11.6296C11.1438 12.1235 8.85618 12.1235 7.44521 11.6296L3 10.0738Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5548 3.37038L18.9418 5.60582C20.3527 6.09966 20.3527 6.90034 18.9418 7.39418L12.5548 9.62962C11.1438 10.1235 8.85618 10.1235 7.44521 9.62962L1.05823 7.39418C-0.352743 6.90034 -0.352743 6.09966 1.05823 5.60582L7.44521 3.37038C8.85618 2.87654 11.1438 2.87654 12.5548 3.37038Z",
  fill: "white"
});

var SvgIcnTrainingCenter = function SvgIcnTrainingCenter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcnTrainingCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-training-center.f69ffaf6.svg";
export { ForwardRef as ReactComponent };